import * as React from 'react'
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

type AssignedToProps = {
	dialogOnly?: boolean
	onClose?: () => void
	assignedTo: string
}

const AssignedToDialog = ({ assignedTo, dialogOnly = false, onClose }: AssignedToProps) => {
	const [open, setOpen] = React.useState(dialogOnly)

	return (
		<>
			{!dialogOnly && (
				<Button
					onClick={() => setOpen(true)}
					variant='contained'
					size='small'
					sx={{
						minWidth: '0.5vw',
						backgroundColor: '#b0bec5', // Muted blue-gray color
						color: '#37474f',
					}}
				>
					<MoreHorizIcon />
				</Button>
			)}
			<Dialog
				open={open}
				onClose={() => {
					setOpen(false)
					onClose?.()
				}}
				maxWidth='xl'
			>
				<DialogTitle>Assigned To</DialogTitle>
				<DialogContent>
					<ul>
						{assignedTo.split(', ').map((at, index) => (
                            
							<li key={index}>
								<Typography>{at}</Typography>
							</li>
						))}
					</ul>
				</DialogContent>
			</Dialog>
		</>
	)
}

export default AssignedToDialog
